const messages = {
    en: {
      users: "Users",
      addQuestion: "Add question",
      editQuestion: "Edit question",
      firstt: "First, please select subject:",
      select: "Select subject",
      currentSubject: "Current subject",
      questHasBeenAddedSucc: "Question/answers has been added successfully, thanks",
      filterResults: "Filter results",
      itemsPerPage: "Items qty per page",
      status: "Status",
      subject: "Subject",
      cleareditedList: "Clear edited questions list",

    },
    ru: {
      users: "Пользователи",
      addQuestion: "Добавить вопрос",
      editQuestion: "Редактировать вопрос",
      firstt: "Сначала выберите тему:",
      select: "Bыберите тему",
      currentSubject: "Текущая тема",
      questHasBeenAddedSucc: "Вопрос/ответы успешно добавлены, спасибо",
      filterResults: "Фильтровать результаты",
      itemsPerPage: "Pез. на страницу",
      status: "Cтaтyc",
      cleareditedList: "Clear edited questions list",
    }
  };

  export default messages;